module.exports = __webpack_public_path__ + "static/img/14.df784ed6.png";